"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logDeprecation = exports.log = void 0;
var log = function log(message, level) {
  if (level === void 0) {
    level = 'warn';
  }
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console[level](message);
  }
};
exports.log = log;
var logDeprecation = function logDeprecation(message) {
  log("[Deprecation] " + message);
};
exports.logDeprecation = logDeprecation;